// 主题配置（被 RightPanel.jsx 的 SettingsTab 使用）
export const THEMES = [
    {
        label: "宣纸米白",
        paper: "#f5edd8",
        paperWarm: "#ede0c4",
        paperDeep: "#d4c4a0",
        paperShadow: "#c4b080",
        ink: "#1a1208"
    },
    {
        label: "翠竹青绿",
        paper: "#e8f0e0",
        paperWarm: "#dce9d0",
        paperDeep: "#c0d8b0",
        paperShadow: "#a0c090",
        ink: "#1a2a14"
    },
    {
        label: "古铜暖棕",
        paper: "#f0e8d8",
        paperWarm: "#e8dcc8",
        paperDeep: "#d0c0a0",
        paperShadow: "#b8a880",
        ink: "#2a1a10"
    },
    {
        label: "墨夜深黑",
        paper: "#1a1208",
        paperWarm: "#221a0a",
        paperDeep: "#2e2410",
        paperShadow: "#3a3018",
        ink: "#d4c4a0"
    },
];
